import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@material-ui/core';

import styles from './page-error.less';

interface Props {
    message: string | undefined | null;
    onClose: () => void;
    messageClass?: string;
    showError?: boolean;
    reserveSpace?: boolean;
    absolute?: boolean;
}

export const PageError: React.SFC<Props> = ({
    message,
    onClose,
    messageClass,
    showError,
    reserveSpace,
    absolute,
}) => (
    <React.Fragment>
        {reserveSpace && (!showError || absolute) ? <div className={styles.reserved} /> : null}
        {message && showError !== false ? (
            <div
                className={classnames(styles.messageBar, messageClass || 'page-error', {
                    [styles.absolute]: absolute,
                })}
            >
                <div className={classnames('centered-content', styles.centeredContent)}>
                    {message /* TODO: nl2br */}
                </div>
                {}
                <a className={styles.close} onClick={onClose}>
                    <Icon>close</Icon>
                </a>
                {}
            </div>
        ) : null}
    </React.Fragment>
);
